/**
 * Custom JS by Hizu from RoarTheme
 * https://haloroar.ticksy.com
 * App: RT: Terms and Conditions Box
 * URL: https://apps.shopify.com/terms-and-conditions-in-cart
 */
(() => {
  "use strict";

  const WIDGET_SELECTOR = ".rale-widget";
  const DEFAULT_LOCALE = "en";
  const MESSAGE_KEY = "message";
  const ERROR_KEY = "error_message";
  const LINK_KEYS = Object.freeze({ link: "link-1781431754091" });

  const TRANSLATIONS = Object.freeze({
    en: {
      [MESSAGE_KEY]: `I understand that I am purchasing a digital knitting pattern that is delivered immediately as a downloadable file. I expressly consent to immediate delivery and acknowledge that I will lose my statutory right of withdrawal once the delivery of the digital content has begun. If there is an issue on our side, we will always help you. Please see our {${LINK_KEYS.link}}.`,
      [ERROR_KEY]:
        "You must accept the refund policy before proceeding with your purchase.",
      labels: {
        [LINK_KEYS.link]: "Refund Policy",
      },
    },
  });

  const getSettings = () => window?.roarJs?.LegalConfig?.metafields?.settings;

  const isEnabled = (settings) => Boolean(settings) && settings.enabled === "1";

  const getParam = (settings) => {
    const { param } = settings;
    return param?.links ? param : null;
  };

  const getLocale = () => window.Shopify?.locale || DEFAULT_LOCALE;

  const resolveTranslation = (locale) => TRANSLATIONS[locale] || null;

  const applyLabels = (param, labels) => {
    Object.entries(labels).forEach(([key, label]) => {
      if (param.links[key]) param.links[key].label = label;
    });
  };

  const applyTranslation = (param, translation) => {
    param[MESSAGE_KEY] = translation[MESSAGE_KEY];
    param[ERROR_KEY] = translation[ERROR_KEY];
    applyLabels(param, translation.labels);
    return param;
  };

  const commitParam = (param) => {
    window.roarJs.LegalConfig.metafields.settings.param = param;
  };

  const removeWidgets = () => {
    document
      .querySelectorAll(WIDGET_SELECTOR)
      .forEach((element) => element.remove());
  };

  const renderLegal = () => {
    removeWidgets();
    window.roarJs.Legal.init();
  };

  const bootstrap = () => {
    const settings = getSettings();
    if (!isEnabled(settings)) return;

    const param = getParam(settings);
    if (!param) return;

    const translation = resolveTranslation(getLocale());
    if (translation) applyTranslation(param, translation);

    commitParam(param);
    renderLegal();
  };

  document.addEventListener("DOMContentLoaded", bootstrap);
})();
